import { TOKEN_TYPE } from "../TokenType.js";
import Token from "../Token.js";

export default class RightTupleToken extends Token {
    constructor( value ) {
        super( TOKEN_TYPE.RIGHT_TUPLE, value );
    }

    toString() {
        return this.value;
    }
}
